import { Vue, Component, Prop, Watch } from 'vue-property-decorator';
import * as d3 from 'd3';

@Component({
    name: 'data-lake-report-chart',
})

export default class DataLakeReportChart extends Vue {

    // -------------------------------------------------------
    // Properties

    @Prop()
    private axisLabels: any;

    @Prop()
    private xScaleName!: string;

    @Prop()
    private yScaleName!: string;

    @Prop()
    private chartData: any;

    @Prop({default: 350})
    private height!: number;

    private margin: any = {
        top: 30,
        left: 100,
        bottom: 70,
        right: 30,
    };

    @Watch('chartData')
    private onWatchData() {
        this.drawChart();
    }

    // -------------------------------------------------------
    // Actions

    // -------------------------------------------------------
    // Hooks

    private mounted() {
        this.drawChart();
    }


    // -------------------------------------------------------
    // Methods

    private drawChart() {
        const el = this.$el;
        const margin = this.margin;
        const chartData = this.chartData;
        const width = el.clientWidth - margin.left - margin.right;
        const height = this.height - margin.top - margin.bottom;

        d3.select(el).select('svg').remove();
        const svg = d3.select(el).append('svg')
            .attr('id', 'domain-chart-container')
            .attr('width', width + margin.left + margin.right)
            .attr('height', height + margin.top + margin.bottom);

        const svgGroup = svg.append('g')
            .attr('transform', `translate(${margin.left},${margin.top})`);

        const color = d3.scaleLinear()
            .domain([0, chartData.length])
            .range(['#00ace9' as any, '#c1dbee' as any]);
        const chartWith = chartData.length * 100 > width ? width : chartData.length * 100;
        const x = d3.scaleBand()
            .domain(chartData.map((item: any) => item[this.xScaleName]))
            .range([0, chartWith])
            .padding(.2);

        const y: any = d3.scaleLinear()
            .domain([0, d3.max(chartData, (d: any) => d[this.yScaleName] as number) as number])
            .range([height, 0]);

        svgGroup.append('g')
            .attr('class', 'x-axis')
            .attr('transform', `translate(0, ${height})`)
            .call(d3.axisBottom(x));

        svgGroup.append('g')
            .attr('class', 'y-axis')
            .call(d3.axisLeft(y));

        const rectGroup = svgGroup.append('g')
            .selectAll('.rect-box')
            .data(chartData)
            .enter()
            .append('rect')
            .attr('class', 'rect-box')
            .attr('x', (d: any) => x(d[this.xScaleName]) as number)
            .attr('y', y(0))
            .attr('rx', 10)
            .attr('width',  (d: any) => x.bandwidth())
            // .style('fill', (d: any, i: number) => color(i))
            .on('click', (d: any) => {
                this.$emit('onSelectProvider', d);
            });

        rectGroup.transition()
            .duration(1000)
            .attr('y', (d: any) => y(d[this.yScaleName]))
            .attr('height',  (d: any) => height - y(d[this.yScaleName]));
        if (this.axisLabels) {
            const labelGroups = svgGroup.append('g')
                .attr('transform', `translate(${ -margin.left / 2}, ${height +  50})`);
            labelGroups.append('text')
                .attr('class', 'x-axis-text')
                .attr('x', width / 2)
                .text(this.axisLabels.xAxis);

            labelGroups.append('text')
                .attr('class', 'y-axis-text')
                .attr('x', height / 2)
                .text(this.axisLabels.yAxis);
        }
    }

}
